<template>
  <table class="table">
    <tr>
      <th>
        新使用者名
        <span class="must">必須</span>
      </th>
      <td>
        <validation-provider
          name="MEIHEN_SIYOSYA_MEI"
          v-slot="{ errors }"
          rules="required|max:20|char"
        >
          <b-form-input
            ref="MEIHEN_SIYOSYA_MEI"
            class="col-md-8"
            maxlength="20"
            v-model="form.MEIHEN_SIYOSYA_MEI"
            :state="errors.length ? false : null"
            placeholder="鈴木太郎"
            trim
            @blur="
              form.MEIHEN_SIYOSYA_MEI = replaceChar(form.MEIHEN_SIYOSYA_MEI)
            "
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </td>
    </tr>
    <tr v-if="isLease">
      <th>
        新使用者名（ふりがな）
        <span class="must">必須</span>
      </th>
      <td>
        <validation-provider
          name="MEIHEN_SIYOSYA_MEI_KANA"
          v-slot="{ errors }"
          rules="required|max:40|hiragana"
        >
          <b-form-input
            ref="MEIHEN_SIYOSYA_MEI_KANA"
            class="col-md-8"
            maxlength="40"
            v-model="form.MEIHEN_SIYOSYA_MEI_KANA"
            :state="errors.length ? false : null"
            placeholder="すずきたろう"
            trim
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </td>
    </tr>
    <tr v-if="isLease">
      <th>新使用者 郵便番号</th>
      <td>
        <div class="row">
          <div class="col-4 col-md-3">
            <validation-provider
              v-slot="{ errors }"
              rules="numeric|digits:3"
              name="MEIHEN_SIYOSYA_YUBIN1"
            >
              <b-form-input
                type="tel"
                ref="MEIHEN_SIYOSYA_YUBIN1"
                maxlength="3"
                v-model="form.MEIHEN_SIYOSYA_YUBIN1"
                :state="errors.length ? false : null"
                placeholder="160"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
          <span class="py-2">-</span>
          <div class="col-4 col-md-3">
            <validation-provider
              v-slot="{ errors }"
              rules="numeric|digits:4"
              name="MEIHEN_SIYOSYA_YUBIN2"
            >
              <b-form-input
                type="tel"
                ref="MEIHEN_SIYOSYA_YUBIN2"
                maxlength="4"
                v-model="form.MEIHEN_SIYOSYA_YUBIN2"
                :state="errors.length ? false : null"
                placeholder="0023"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
          <button
            type="button"
            class="btn btn-success bold"
            @click="searchAddress"
            :disabled="!isYubinSearch"
            style="height: 40px"
          >
            検索
          </button>
        </div>
      </td>
    </tr>
    <tr v-if="isLease">
      <th>
        新使用者 都道府県・市区郡
        <span class="must">必須</span>
      </th>
      <td>
        <div class="row">
          <div class="col-4 col-md-4 col-lg-3 pr-0">
            <validation-provider
              v-slot="{ errors }"
              name="MEIHEN_SIYOSYA_TODO_CD"
              rules="required"
              ref="MEIHEN_SIYOSYA_TODO_MEI"
            >
              <b-form-select
                v-model="form.MEIHEN_SIYOSYA_TODO_CD"
                ref="MEIHEN_SIYOSYA_TODO_CD"
                :state="errors.length ? false : null"
                :options="prefList"
                trim
                @change="changePref"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
          <div class="col-7 col-md-5 col-lg-4">
            <validation-provider
              v-slot="{ errors }"
              name="MEIHEN_SIYOSYA_SHIKU_CD"
              rules="required"
              ref="MEIHEN_SIYOSYA_SHIKU_MEI"
            >
              <b-form-select
                :disabled="!cityList.length"
                ref="MEIHEN_SIYOSYA_SHIKU_CD"
                v-model="form.MEIHEN_SIYOSYA_SHIKU_CD"
                :state="errors.length ? false : null"
                :options="cityList"
                trim
                @change="changeCity"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
        </div>
      </td>
    </tr>
    <tr v-if="isLease">
      <th>
        新使用者 町名・番地
        <span class="must">必須</span>
      </th>
      <td>
        <validation-provider
          name="MEIHEN_SIYOSYA_BANCHI"
          v-slot="{ errors }"
          rules="required|max:25|char"
        >
          <b-form-input
            maxlength="25"
            ref="MEIHEN_SIYOSYA_BANCHI"
            v-model="form.MEIHEN_SIYOSYA_BANCHI"
            :state="errors.length ? false : null"
            placeholder="西新宿7－4－3 升本ビル4F"
            trim
            @blur="
              form.MEIHEN_SIYOSYA_BANCHI = replaceChar(
                form.MEIHEN_SIYOSYA_BANCHI
              )
            "
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </td>
    </tr>
    <tr v-if="isLease">
      <th>
        新使用者 TEL
        <span class="must">必須</span>
      </th>
      <td>
        <validation-provider
          name="MEIHEN_SIYOSYA_TEL"
          v-slot="{ errors }"
          rules="required|tel"
        >
          <b-form-input
            class="col-md-6"
            ref="MEIHEN_SIYOSYA_TEL"
            maxlength="17"
            v-model="form.MEIHEN_SIYOSYA_TEL"
            :state="errors.length ? false : null"
            placeholder="03-5937-4777"
            trim
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </td>
    </tr>
    <tr v-if="isLease">
      <th>
        新使用者 メールアドレス
        <br v-if="isTablet" />
        <span class="must">必須</span>
      </th>
      <td>
        <validation-provider
          name="MEIHEN_SIYOSYA_MAIL_ADDR"
          v-slot="{ errors }"
          rules="required|max:50|email"
        >
          <b-form-input
            v-model="form.MEIHEN_SIYOSYA_MAIL_ADDR"
            ref="MEIHEN_SIYOSYA_MAIL_ADDR"
            class="col-md-8"
            maxlength="50"
            :state="errors.length ? false : null"
            placeholder="yamada@mail.co.jp"
            trim
          />
          <b-form-invalid-feedback>
            <span class="border-red">{{ errors[0] }}</span>
          </b-form-invalid-feedback>
        </validation-provider>
      </td>
    </tr>
  </table>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'
import _ from 'lodash'

export default {
  name: 'NewUser',

  mixins: [Mixin],

  props: {
    /** データ取得フラグ */
    isGetData: {
      type: Boolean,
      default: false,
    },

    /** データ設定フラグ */
    isSetData: {
      type: Boolean,
      default: false,
    },

    /** オブザーバー */
    observer: {
      type: Object,
      default: null,
    },

    /** 親入力データ */
    parent: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 市区町村リスト */
    cityList: [],

    /** 入力データ */
    form: {
      MEIHEN_SIYOSYA_MEI: null,
      MEIHEN_SIYOSYA_MEI_KANA: null,
      MEIHEN_SIYOSYA_YUBIN1: null,
      MEIHEN_SIYOSYA_YUBIN2: null,
      MEIHEN_SIYOSYA_TODO_CD: null,
      MEIHEN_SIYOSYA_TODO_MEI: null,
      MEIHEN_SIYOSYA_SHIKU_CD: '',
      MEIHEN_SIYOSYA_SHIKU_MEI: null,
      MEIHEN_SIYOSYA_BANCHI: null,
      MEIHEN_SIYOSYA_TEL: null,
      MEIHEN_SIYOSYA_MAIL_ADDR: null,
    },
  }),

  methods: {
    /** 入力データを精設定する */
    setData() {
      if (this.parent) {
        for (var name in this.form) {
          if (this.parent[name] !== undefined)
            this.form[name] = this.parent[name]
        }
        this.getCityList()
      }
    },

    /** 都道府県変更 */
    changePref() {
      const todoCd = this.form.MEIHEN_SIYOSYA_TODO_CD
      this.form.MEIHEN_SIYOSYA_TODO_MEI = null
      this.form.MEIHEN_SIYOSYA_SHIKU_CD = ''
      this.form.MEIHEN_SIYOSYA_SHIKU_MEI = null
      if (todoCd) {
        this.form.MEIHEN_SIYOSYA_TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList()
      } else this.cityList = []
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.form.MEIHEN_SIYOSYA_SHIKU_CD
      this.form.MEIHEN_SIYOSYA_SHIKU_MEI = null
      if (shikuCd) {
        this.form.MEIHEN_SIYOSYA_SHIKU_MEI = this.getText(
          this.cityList,
          shikuCd
        )
      }
    },

    /** 市区町村リスト取得 */
    getCityList() {
      if (!this.form.MEIHEN_SIYOSYA_TODO_CD) return
      return Store.dispatch(
        'address/getCityList',
        this.form.MEIHEN_SIYOSYA_TODO_CD
      ).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
      })
    },

    /** 郵便番号検索 */
    searchAddress() {
      this.getAreaFromZipCd(
        `${this.form.MEIHEN_SIYOSYA_YUBIN1}${this.form.MEIHEN_SIYOSYA_YUBIN2}`
      ).then(async (item) => {
        if (item) {
          this.form.MEIHEN_SIYOSYA_TODO_CD = ('00' + item.prefcode).slice(-2)
          this.form.MEIHEN_SIYOSYA_TODO_MEI = this.getText(
            this.prefList,
            this.form.MEIHEN_SIYOSYA_TODO_CD
          )
          this.form.MEIHEN_SIYOSYA_SHIKU_MEI = item.address2
          this.form.MEIHEN_SIYOSYA_BANCHI = item.address3
          await this.getCityList()
          const city = this.getParam(
            this.cityList,
            this.form.MEIHEN_SIYOSYA_SHIKU_MEI,
            'text'
          )
          if (city) this.form.MEIHEN_SIYOSYA_SHIKU_CD = city.value
        }
      })
    },

    /** 表示された入力データのみ設定する */
    cleanup() {
      let d = _.cloneDeep(this.form)
      for (var name in d) {
        if (!this.$refs[name]) delete d[name]
      }
      return d
    },
  },

  computed: {
    /** 郵便検索可能か */
    isYubinSearch() {
      return (
        this.form.MEIHEN_SIYOSYA_YUBIN1 &&
        this.form.MEIHEN_SIYOSYA_YUBIN2 &&
        this.observer &&
        this.observer.fields.MEIHEN_SIYOSYA_YUBIN1 &&
        this.observer.fields.MEIHEN_SIYOSYA_YUBIN2 &&
        !this.observer.fields.MEIHEN_SIYOSYA_YUBIN1.failed &&
        !this.observer.fields.MEIHEN_SIYOSYA_YUBIN2.failed
      )
    },
  },

  watch: {
    /* データ取得フラグ監視 */
    async isGetData(val) {
      if (val) this.$emit('setData', this.cleanup())
    },

    /* データ設定フラグ監視 */
    async isSetData(val) {
      if (val) this.setData()
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/meihen/NewUser.vue